var DaysBeforeOptions;
(function (DaysBeforeOptions) {
    DaysBeforeOptions[DaysBeforeOptions["THIRTY"] = 30] = "THIRTY";
    DaysBeforeOptions[DaysBeforeOptions["FOURTEEN"] = 14] = "FOURTEEN";
    DaysBeforeOptions[DaysBeforeOptions["SEVEN"] = 7] = "SEVEN";
    DaysBeforeOptions[DaysBeforeOptions["THREE"] = 3] = "THREE";
    DaysBeforeOptions[DaysBeforeOptions["ONE"] = 1] = "ONE";
})(DaysBeforeOptions || (DaysBeforeOptions = {}));
export default DaysBeforeOptions;
